import React from 'react';
import { pointer } from 'd3-selection';

import COLORS from '../../../../constants/colors.constants';

const Bar = ({
  id,
  x,
  y,
  xScale,
  yScale,
  width,
  height,
  onClick,
  onHover,
  fill = COLORS.brand,
}) => {
  const handleClick = () => onClick(x, y);
  const handleHover = e => onHover({ x, y }, pointer(e));
  const handleItemLeave = () => onHover(null, null);
  return (
    <rect
      id={id}
      className="bar"
      x={xScale(x)}
      y={yScale(y)}
      width={width}
      height={height}
      fill={fill}
      onClick={handleClick}
      onMouseOver={handleHover}
      onMouseLeave={handleItemLeave}
    />
  )
}

export const Bars = ({
  data,
  xScale,
  yScale,
  height,
  barColor,
  id = 'bars',
  onItemClick = () => {},
  onItemHover = () => {},
}) => (
  <g>
    {
      data?.length && (
        data.map(item => (
          <Bar
            key={`bar-${id}-${item.y}-${item.x}`}
            id={`bar-${id}-${item.y}-${item.x}`}
            x={item.x}
            y={item.y}
            xScale={xScale}
            yScale={yScale}
            fill={barColor}
            height={height - yScale(item.y)}
            width={xScale.bandwidth()}
            onClick={onItemClick}
            onHover={onItemHover}
          />
        ))
      )
    }
  </g>
)


export default Bars;
